var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscontinue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 13.3335C14.0697 13.3335 14.6667 13.9304 14.6667 14.6668V21.3335C14.6667 22.0699 14.0697 22.6668 13.3333 22.6668C12.597 22.6668 12 22.0699 12 21.3335V14.6668C12 13.9304 12.597 13.3335 13.3333 13.3335Z",
    fill: "#F15B59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6673 13.3335C19.4037 13.3335 20.0007 13.9304 20.0007 14.6668V21.3335C20.0007 22.0699 19.4037 22.6668 18.6673 22.6668C17.9309 22.6668 17.334 22.0699 17.334 21.3335V14.6668C17.334 13.9304 17.9309 13.3335 18.6673 13.3335Z",
    fill: "#F15B59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3327 2.6665C11.1235 2.6665 9.33268 4.45736 9.33268 6.6665H5.33268H3.99935C3.26297 6.6665 2.66602 7.26346 2.66602 7.99984C2.66602 8.73622 3.26297 9.33317 3.99935 9.33317H5.33268V25.3332C5.33268 27.5423 7.12354 29.3332 9.33268 29.3332H22.666C24.8752 29.3332 26.666 27.5423 26.666 25.3332V9.33317H27.9993C28.7357 9.33317 29.3327 8.73622 29.3327 7.99984C29.3327 7.26346 28.7357 6.6665 27.9993 6.6665H26.666H22.666C22.666 4.45737 20.8752 2.6665 18.666 2.6665H13.3327ZM19.9993 6.6665C19.9993 5.93012 19.4024 5.33317 18.666 5.33317H13.3327C12.5963 5.33317 11.9993 5.93012 11.9993 6.6665H19.9993ZM9.33268 9.33317H7.99935V25.3332C7.99935 26.0695 8.5963 26.6665 9.33268 26.6665H22.666C23.4024 26.6665 23.9993 26.0695 23.9993 25.3332V9.33317H22.666H9.33268Z",
    fill: "#F15B59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscontinue);
export default __webpack_public_path__ + "static/media/Discontinue.a0a1c203cf8425499aff44d12eae2fae.svg";
export { ForwardRef as ReactComponent };